import { EAccountPlansType } from "../../Enum/EAccountPlansType"
import { SubscriptionPlanPeriodPricing } from "./SubscriptionPlanPeriodPricing"

export class SubscriptionPlanPricing {
  planType: EAccountPlansType

  platformFeePercent: number

  limitMonthlyOrders: number

  limitProducts: number

  price: number

  periods: SubscriptionPlanPeriodPricing[]

  pixEnabled: boolean

  constructor(data: Partial<SubscriptionPlanPricing> = {}) {
    this.planType = data.planType ?? EAccountPlansType.None

    this.platformFeePercent = data.platformFeePercent ?? 0

    this.limitMonthlyOrders = data.limitMonthlyOrders ?? 0

    this.limitProducts = data.limitProducts ?? 0

    this.price = data.price ?? 0

    this.periods = (data.periods ?? []).map((item) => new SubscriptionPlanPeriodPricing(item))

    this.pixEnabled = data.pixEnabled ?? true
  }
}
